import $ from 'zepto';
// var util = require('../common/util.js');
import util from '../common/util.js';
// var msgbox = require('../common/msgbox.js');
import msgbox from '../common/msgbox.js';

var islottery = false;
var actid = active_cfg.base.actid;
var jinku = {};

if (util.isWeixin()) {
	jinku['urlname'] = '立即使用';
	jinku['url'] = 'http://act.vip.xunlei.com/weixin_huiyuan/weixin_pay/';
} else {
	jinku['urlname'] = '立即查看';
	jinku['url'] = 'http://vip.xunlei.com/vip_service/mycenter/vault.html';
}

var msg_cofig = {
	"address": {
		opts: {
			btn_title: "填写资料",
			btn_href: "javascript:void(0);",
			btn_target: "0",
			boxTitle: "恭喜亲中奖啦！",
			btn_class: "act_address"
		}
	},
	"info": {
		opts: {
			btn_title: "我的收货地址",
			btn_href: "javascript:void(0);",
			btn_target: "0",
			boxTitle: "恭喜亲中奖啦！",
			btn_class: "act_qq_sub"
		}
	}
}

$.fn.lottery = function(_config) {
	var config = {
		giftItem: 'li', //单个奖品选择器
		sort: [0, 1, 2, 7, 3, 6, 5, 4], //排序，默认为顺序
		targetClass: 'on', //选中时的class，默认on
		fastSpeed: 80, //快速阶段的速度(定时器时间间隔)，默认80
		slowSpeed: 444, //慢速阶段的速度(定时器时间间隔)，默认400
		startStep: 5, //开头的慢速阶段跑几步，默认4
		endStep: 6, //结束的慢速阶段跑几步，默认4
		startBtn: '.act_lottery_btn',
		lottery_url: location.protocol + '//dyactive2.vip.xunlei.com/iface/?action=getLottery&actid=', //获取抽奖结果的url
		ani: true,
		lotteryAfter: null,
		gid: ''
	};

	$.extend(config, _config);

	var islottery;
	var timeIntervalId; //定时器
	var curStatus; //0:停止  1:启动截断 2:中间快速阶段  3:中奖减速阶段
	var giftIndex; //抽中奖品的位置,-1表示还没获得
	var curIndex; //当前在哪个位置
	var runCount; //累计总共跑了几个位置
	var endCallback; //用来注册结束时回调的函数
	function reset() {
		curStatus = 0; //0:停止  1:启动截断 2:中间快速阶段  3:中奖减速阶段
		giftIndex = -1; //抽中奖品的位置,-1表示还没获得
		curIndex = 0; //当前在哪个位置
		runCount = 0; //累计总共跑了几个位置
	}
	reset();
	var $lotteryBox = this.eq(0);
	var giftCount = $lotteryBox.find(config.giftItem).length; //奖品总数
	var idx = 0;
	if (!config.sort || config.sort.length != giftCount) {
		$lotteryBox.find(config.giftItem).each(function() {
			$(this).attr('sort', idx);
			idx++;
		});
	} else {
		$lotteryBox.find(config.giftItem).each(function() {
			$(this).attr('sort', config.sort[idx]);
			idx++;
		});
	}

	function run() {
		reset();
		focusToNext();
		curStatus = 1; //开始
		myInterval(config.slowSpeed);
	}
	
	//设置定时器，私有函数
	function myInterval(speed) {
		clearInterval(timeIntervalId);
		timeIntervalId = setInterval(function() {
			runCount++;
			curIndex = runCount % giftCount;
			focusToNext();
			stepFunction();
		}, speed);
	}

	//设置当前dom状态，私有函数
	function focusToNext() {
		$lotteryBox.find(config.giftItem).removeClass(config.targetClass);
		$lotteryBox.find(config.giftItem + '[sort="' + curIndex + '"]').eq(0).addClass(config.targetClass);
	}

	//每跑一步检测当前状态，私有函数
	function stepFunction() {
		if (curStatus == 1 && runCount == config.startStep) {
			curStatus = 2; //加速
			myInterval(config.fastSpeed);
		}
		if (curStatus == 2 && (runCount >= (config.startStep + giftCount * 2))) { //至少要快速跑一圈
			if (giftIndex != -1) {
				var needNum = giftCount - config.endStep - (curIndex - giftIndex);
				if (needNum == 0 || needNum == giftCount) {
					curStatus = 3; //中奖减速阶段
					myInterval(config.slowSpeed);
				}
			}
		}
		if (curStatus == 3 && curIndex == giftIndex) {
			end();
		}
	}

	function end() {
		clearInterval(timeIntervalId);
		setTimeout(function() {
			endCallback && endCallback();
		}, 200);
	}

	function setGift(_giftIndex, _endCallback) {
		run();
		giftIndex = parseInt(_giftIndex);
		endCallback = _endCallback;
	}

	function afterLottery(rs) {
		if(config.after && (config.after(rs) === false)) {
			return;
		}
		if (msg_cofig[rs.data.fafang]) {
			msgbox.showErrorMsg(rs.msg, msg_cofig[rs.data.fafang]['opts']);
		} else {
			msgbox.showErrorMsg(rs.msg);
		}
	}

	function start() {
		if(islottery) return;
		islottery = true;
		$.ajax({
			url: config.lottery_url,
			dataType: 'jsonp',
			data: {
				actid: actid,
				gid: config.gid
			},
			success: function(rs) {
				if(config.before && (config.before(rs) === false)) {
					islottery = false;
					return;
				}
				if (rs.result == 0) {
					if(config.ani) {
						setGift(rs.data.frontid, function(){
							afterLottery(rs);
							islottery = false;
						});
					} else {
						afterLottery(rs);
						islottery = false;
					}
				} else {
					msgbox.showErrorMsg(rs.msg);
					islottery = false;
				}
			}
		})
	}
	$(config.startBtn).on('click', function(){
		if(!haslogin()){
		   login();
		   return false;
		}

		start();
	});
	return {
		start: start
	};
}



// WEBPACK FOOTER //
// ./src/tools/lottery.js